import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { ISeasonRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';

function seasonRequest(id: string) {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const response: ISeasonRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v1',
          section: 'apiseries',
          subsection: 'seasons',
          type: 'episodes',
          replacement: id,
        },
      })) as unknown as ISeasonRequest;

      const episodes = response.data.items
        .sort((episode1, episode2) => {
          return episode1?.episode < episode2?.episode ? -1 : 1;
        })
        .map((item) => {
          return { ...item, gender: item.gender.id };
        });

      const rail = {
        section: {
          title: `${episodes?.length ? episodes[0]?.title : ''} ${
            episodes?.length && episodes[0]?.season
              ? TranslationManager.get('MISC.EVENTS.SEASON') +
                ' ' +
                episodes[0].season
              : ''
          }`,
          presentationType: RailDisplayMode.PHOTO,
          name: id,
        },
        shows: {
          data: episodes,
          totalEpisodes: episodes?.length
            ? episodes[0]?.totalEpisode
            : undefined,
        },
      };
      const returnRail = new Rail(rail);
      resolve(returnRail.data.length ? [returnRail] : []);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default seasonRequest;
